import { api } from '../../../shared/api/client';

export const getStatistics = (params = {}) => api.post('/statistic/getStatistics', params);
export const getExpandColumns = () => api.get('admin/statistic/getExpandColumns');
export const getStatisticDetail = (username, type, dataSearch = {}) => api.post(
    'admin/statistic/getStatisticDetail',
    dataSearch,
    { params: { username, type } },
);
export const adminGetStatistics = (type, params = {}) => api.post(
    'admin/statistic/getStatistics',
    params,
    { params: { type } },
);
